import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import * as Icons from '../../components/wr/icons.ts';
export interface Signature {
    Args: {
        icon?: keyof typeof Icons;
    };
}
export default class LinkOrButtonIconComponent extends Component<Signature> {
    get icon() {
        return this.args.icon ? Icons[this.args.icon] : undefined;
    }
    static{
        template(`
    {{#if this.icon}}
      <this.icon aria-hidden={{true}} />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjLy1wcml2YXRlL2NvbXBvbmVudHMvbGluay1vci1idXR0b24taWNvbi5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuaW1wb3J0ICogYXMgSWNvbnMgZnJvbSAnLi4vLi4vY29tcG9uZW50cy93ci9pY29ucy50cyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU2lnbmF0dXJlIHtcbiAgQXJnczogeyBpY29uPzoga2V5b2YgdHlwZW9mIEljb25zIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIExpbmtPckJ1dHRvbkljb25Db21wb25lbnQgZXh0ZW5kcyBDb21wb25lbnQ8U2lnbmF0dXJlPiB7XG4gIGdldCBpY29uKCkge1xuICAgIHJldHVybiB0aGlzLmFyZ3MuaWNvbiA_IEljb25zW3RoaXMuYXJncy5pY29uXSA6IHVuZGVmaW5lZDtcbiAgfVxuXG4gIDx0ZW1wbGF0ZT5cbiAgICB7eyNpZiB0aGlzLmljb259fVxuICAgICAgPHRoaXMuaWNvbiBhcmlhLWhpZGRlbj17e3RydWV9fSAvPlxuICAgIHt7L2lmfX1cbiAgPC90ZW1wbGF0ZT5cbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUMzQyxZQUFZLFdBQVcsK0JBQStCO0FBRXRELGlCQUFpQjtJQUNmO1FBQVEsb0JBQW9COzs7QUFHOUIsZUFBZSxNQUFNLGtDQUFrQyxVQUFVO0lBQy9ELElBQUksT0FBTztRQUNULE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEdBQUcsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUc7SUFDbEQ7SUFFQSxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7O0VBSVYsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBSkE7QUFLWiJ9